import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const BUTTON = derivedThemeValues(_ref => {
  let {
    theme
  } = _ref;
  return {
    default: {
      backgroundColor: theme.color.secondary,
      foregroundColor: theme.color.bodyFont,
      hover: {
        backgroundColor: theme.color.secondaryHover
      }
    }
  };
});